import { memoize } from 'lodash';
import { createSelector } from 'reselect';
import { State } from '.';
import { CompositeAllergy } from '../../models/composite-allergy';

const getCompositeAllergyIdsByTextSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<CompositeAllergy>) => memoize((
        text: Undefinable<string>
    ) => {
        const textLower = (text || '').toLowerCase();
        return Object
            .keys(byId)
            .filter(x => byId[x] && byId[x]!.description.toLowerCase().startsWith(textLower))
            .map(x => +x);
    })
);

const getOtherCompositeAllergyIdsSelector = createSelector(
    (state: State) => state.byId,
    (byId: Dictionary<CompositeAllergy>) => memoize((
        ids: Undefinable<number>[]
    ) => ids.filter(x => x && !byId[x]) as number[])
);

export const selectors = {
    checkSearched: (
        state: State,
        text: string
    ): boolean => state.searchedTextHash[text] || false,
    getCompositeAllergy: (
        state: State,
        id: Undefinable<DictionaryKey>
    ): Undefinable<CompositeAllergy> => state.byId[id || ''],
    getCompositeAllergyIds: (
        state: State
    ): number[] => state.allIds,
    getCompositeAllergyIdsByText: (
        state: State,
        text: Undefinable<string>
    ): number[] => getCompositeAllergyIdsByTextSelector(state)(text),
    getLoading: (
        state: State,
        loadingKey: string
    ): boolean => state.loading[loadingKey] || false,
    getOtherCompositeAllergyIds: (
        state: State,
        ids: Undefinable<number>[]
    ): number[] => getOtherCompositeAllergyIdsSelector(state)(ids)
};
